import { IsString } from "class-validator";
import { AbstractJSONModel } from "./master-model";

export interface ITaskPut {
  name: string;
  hours: number;
  id: number;
}

export class EmployeeTask extends AbstractJSONModel {
  public id = -1;
  @IsString()
  public name = "";
  public hours = 0;
  public employment_id = 0;

  convertToPutObject() {
    const t: ITaskPut = Object.assign({});
    t.hours = this.hours;
    t.name = this.name;
    t.id = this.id;
  }
}

export enum rowState {
  Created = "CREATED",
  Updated = "UPDATED",
  Deleted = "DELETED",
  Unset = "UNSET"
}
export class EmploymentTaskState extends EmployeeTask {
  public state: rowState = rowState.Unset;
}
